"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _Popover = _interopRequireDefault(require("../Popover"));
/** Messages that appear on hover and explain elements on the screen */


var Tooltip = function Tooltip(_ref) {
  var children = _ref.children,
      className = _ref.className,
      htmlId = _ref.htmlId,
      tooltipContent = _ref.tooltipContent,
      position = _ref.position;
  return /*#__PURE__*/_react["default"].createElement(_Popover["default"], {
    className: className,
    htmlId: htmlId,
    trigger: ["hover", "focus"],
    popoverContent: tooltipContent,
    position: position,
    tooltip: true
  }, children);
};

Tooltip.defaultProps = {
  position: "bottom"
};
var _default = Tooltip;
exports["default"] = _default;